import { AnyAction } from 'redux';
import { ECS } from '../../../../web/models/constants/getHelpConstants';
import { EcsConfigurationResponse } from '../../../../web/models/getHelp/ecsConfigurationResponse';
import { ExperienceMetaData } from '../../../../web/models/getHelp/experienceConfigurations';
import { License } from '../../../../web/models/getHelp/license';
import * as actionTypes from '../../../models/actionTypes';
import { UserInfo } from '../../../models/apiModels';
import { IGlobalState, initialGlobalState } from '../../../models/reduxState';

const handleSocDataGrabSuccess = (state: IGlobalState = initialGlobalState, action: AnyAction): IGlobalState => {
  return {
    ...state,
    namespace: action.namespace,
    socDataGrabComplete: true,
    market: action.market,
    appVer: action.appVer,
    version: action.version,
    sourceApp: action.sourceApp,
    isPremierTenantEnabled: !!action.supportSettingsConfig && !!action.supportSettingsConfig.IsPremierTenantEnabled,
    isAddClientContextEnabled: !!action.supportSettingsConfig && !!action.supportSettingsConfig.IsAddClientContextEnabled,
  };
};

// Only used for InApp
const handleSupportDataGrabSuccess = (state: IGlobalState = initialGlobalState, action: AnyAction): IGlobalState => {
  return {
    ...state,
    isPremierTenantEnabled: !!action.supportSettingsConfig && !!action.supportSettingsConfig.IsPremierTenantEnabled,
  };
};

const setTheme = (state: IGlobalState = initialGlobalState, action: AnyAction) => {
  return {
    ...state,
    theme: action.theme,
  };
};

const setAccentColor = (state: IGlobalState = initialGlobalState, action: AnyAction) => {
  return {
    ...state,
    accentColor: action.payload,
  };
};

const setDisplayNamespace = (state: IGlobalState = initialGlobalState, action: AnyAction) => {
  return {
    ...state,
    displayNamespace: action.displayNamespace,
  };
};

const setInitializationComplete = (state: IGlobalState = initialGlobalState, action: AnyAction) => {
  return {
    ...state,
    initializationComplete: true,
  };
};

const setSessionData = (state: IGlobalState = initialGlobalState, action: AnyAction): IGlobalState => {
  (window as any).SessionData = action.sessionData;

  return {
    ...state,
    sessionData: action.sessionData,
  };
};

const handleFetchUserInfoSuccess = (
  state: IGlobalState = initialGlobalState,
  action: AnyAction
): IGlobalState => {
  const userInfo = action.userInfo as UserInfo;
  const entitlement = userInfo.Entitlement;
  const tenantInfo = {
    ...state.tenantInfo,
    dataBoundary: userInfo.DataBoundary,
    isDfM: userInfo.IsDfM,
    hasUnifiedContract: !!entitlement && !!entitlement.HasUnifiedContract,
    hasUnifiedEnterpriseContract: !!entitlement && !!entitlement.HasUnifiedEnterpriseContract,
    premierEntitlementId: !!entitlement ? entitlement.PremierEntitlementId: '',
  };
  return {
    ...state,
    tenantInfo,
  };
};

const setMarket = (state: IGlobalState = initialGlobalState, action: AnyAction) => {
  return {
    ...state,
    market: action.market,
  };
};

const updateEcsConfiguration = (state: IGlobalState, ecsResponse: EcsConfigurationResponse): IGlobalState => {
  if (!!ecsResponse) {
    const parameters = ECS.TeamName in ecsResponse ? (ecsResponse[ECS.TeamName] as Record<string, string>) : null;

    const flightList = !!parameters ? Object.keys(parameters).map((key: string) => key + '_' + parameters[key]) : [];

    const configIds =
      !!ecsResponse.ConfigIDs && ECS.TeamName in ecsResponse.ConfigIDs
        ? ecsResponse.ConfigIDs[ECS.TeamName]?.split(',')
        : [];

    return {
      ...state,
      getHelpECS: {
        flightList: flightList,
        configIds: configIds,
        eTag: ecsResponse.Headers?.ETag,
      },
    };
  } else {
    return {
      ...state,
      getHelpECS: {
        flightList: [],
        configIds: [],
        eTag: '',
      },
    };
  }
};

export const GlobalReducer = (state: IGlobalState = initialGlobalState, action: any) => {
  switch (action.type) {
    case actionTypes.GET_EMERALD_CONFIG_SUCCESS:
      return handleSocDataGrabSuccess(state, action);
    case actionTypes.GET_EMERALD_SUPPORTCONFIG_SUCCESS:
      return handleSupportDataGrabSuccess(state, action);
    case actionTypes.SET_THEME:
      return setTheme(state, action);
    case actionTypes.SET_MARKET:
      return setMarket(state, action);
    case actionTypes.SET_DISPLAY_NAMESPACE:
      return setDisplayNamespace(state, action);
    case actionTypes.SET_INITIALIZATION_COMPLETE:
      return setInitializationComplete(state, action);
    case actionTypes.SET_SESSION_DATA:
      return setSessionData(state, action);
    case actionTypes.FETCH_USERINFO_SUCCESS:
      return handleFetchUserInfoSuccess(state, action);
    case actionTypes.UPDATE_THEME:
        return setTheme(state, action);
    case actionTypes.UPDATE_COLOR:
        return setAccentColor(state, action);
    // Todo: Brook Add logic to fetch licenses and update store
    case actionTypes.UPDATE_LICENSES:
      return { ...state, licenses: action.payload as License[] };
    case actionTypes.UPDATE_GETHELP_CONFIG:
      return { ...state, getHelpConfig: action.payload as ExperienceMetaData };
    case actionTypes.UPDATE_ECS_CONFIGURATION:
      return updateEcsConfiguration(state, action.payload as EcsConfigurationResponse);
    default:
      return state;
  }
};
